module.exports = __webpack_public_path__ + "static/img/cover-image-4.680c0ca.png";